import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireComponent = require.context(
    // ścieżka relatywna do komponentów bazowych
    './Base',
    false,
    // Wyrażenie regularne mapujące komponenty
    /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
    // Pobieranie konfiguracji komponentu
    const componentConfig = requireComponent(fileName);

    // Pobieranie nazwy komponentu
    const componentName = upperFirst(
        camelCase(
            fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
        )
    );

    // Rejestracja komponentu globalnie
    Vue.component(
        componentName,
        componentConfig.default || componentConfig
    )
});